if (!window.customElements.get('hero-scroller')) {

  class HeroScroller extends HTMLElement {
    constructor() {
      super();
      this.scrollAnimationPanelsMono = null;
      this.scrollAnimationOverlay = null;
      this.motion = null;
      this.isInitialized = false;
    }

    connectedCallback() {
      // Prevent multiple initializations
      if (this.isInitialized) return;
      
      // Wait for Motion.dev to be ready
      whenReady('motion', (motion) => {
        this.motion = motion;
        
        // Add a small delay to ensure everything is ready
        setTimeout(() => {
          if (!this.isInitialized) {
            this.initScroller();
            this.isInitialized = true;
          }
        }, 100);
      });
    }

    initScroller() {
      console.log("scroller init");

      const section = this.closest('.shopify-section');

      if(!section) {
        console.warn('HeroScroller: No parent section found');
        return;
      }


      if(section.querySelector('.hero-scroller__panels-mono-text') === null) {
        return;
      }

      // Clean up any existing scroll animations
      if (this.scrollAnimationPanelsMono) {
        this.scrollAnimationPanelsMono.stop();
        this.scrollAnimationPanelsMono = null;
      }

      const panelsMonoElement = section.querySelector('.hero-scroller__panels-mono-text');
      if (panelsMonoElement) {
        this.scrollAnimationPanelsMono = this.motion.scroll(
          this.motion.animate(panelsMonoElement, {
            opacity: [0, 1]
          }),
          {
            target: section,
            offset: ['5% start', '15% start']
          }
        );
      }

      if (this.scrollAnimationOverlay) {
        this.scrollAnimationOverlay.stop();
        this.scrollAnimationOverlay = null;
      }      

      const overlayElement = section.querySelector('.hero-scroller__overlay');
      if (overlayElement) {
        this.scrollAnimationOverlay = this.motion.scroll(
          this.motion.animate(overlayElement, {
            opacity: [0, 1]
          }),
          {
            target: section,
            offset: ['0% start', '15% start']
          }
        );
      }      

    }

    disconnectedCallback() {
      console.log('HeroScroller disconnected');
      
      // Clean up scroll animations
      if (this.scrollAnimationPanelsMono) {
        this.scrollAnimationPanelsMono.stop();
        this.scrollAnimationPanelsMono = null;
      }

      if (this.scrollAnimationOverlay) {
        this.scrollAnimationOverlay.stop();
        this.scrollAnimationOverlay = null;
      }      
      
      this.isInitialized = false;
    }
    
  }
  
  customElements.define('hero-scroller', HeroScroller);

}
